import Vue from 'vue'
import input from '@/components/controls/x-input'
import textarea from '@/components/controls/x-textarea'
import checkbox from '@/components/controls/x-checkbox'
import button from '@/components/controls/x-button'
import form from '@/components/controls/x-form'
import formSubmit from '@/components/controls/x-form-submit'
import select from '@/components/controls/x-select'
import spinner from '@/components/controls/x-spinner'
import radioGroup from '@/components/controls/x-radio-group'
import radioButton from '@/components/controls/x-radio-button'
import radioButtonLarge from '@/components/controls/x-radio-button-large'
import slider from '@/components/controls/x-slider'
import rangeSlider from '@/components/controls/x-range-slider'
import datePicker from '@/components/controls/x-date-picker'
import dateRangePicker from '@/components/controls/x-date-range-picker'
import buttonSwitch from '@/components/controls/molecules/x-button-switch'
import tag from '@/components/controls/x-tag'
import multiSelect from '@/components/controls/x-multiselect'
import userAvatar from '@/components/controls/x-user-avatar'
import menu from '@/components/controls/x-menu'
import dateFilters from '@/components/controls/x-date-filters'
import xTagCloud from '@/components/controls/x-tag-cloud'
import XTelInput from '@/components/controls/XTelInput'
import XSwitch from '@/components/controls/x-switch'
import XChip from '@/components/controls/x-chip'
import GenericTooltip from '@/components/generic-tooltip'

Vue.component('XInput', input)
Vue.component('XTextarea', textarea)
Vue.component('XButton', button)
Vue.component('XForm', form)
Vue.component('XFormSubmit', formSubmit)
Vue.component('XSelect', select)
Vue.component('XRadioGroup', radioGroup)
Vue.component('XRadioButton', radioButton)
Vue.component('XRadioButtonLarge', radioButtonLarge)
Vue.component('XSpinner', spinner)
Vue.component('XCheckbox', checkbox)
Vue.component('XRangeSlider', rangeSlider)
Vue.component('XSlider', slider)
Vue.component('XDatePicker', datePicker)
Vue.component('XDateRangePicker', dateRangePicker)
Vue.component('XButtonSwitch', buttonSwitch)
Vue.component('XTag', tag)
Vue.component('XMultiselect', multiSelect)
Vue.component('XUserAvatar', userAvatar)
Vue.component('XMenu', menu)
Vue.component('XDateFilters', dateFilters)
Vue.component('XTagCloud', xTagCloud)
Vue.component('XTelInput', XTelInput)
Vue.component('XSwitch', XSwitch)
Vue.component('XChip', XChip)
Vue.component('XGenericTooltip', GenericTooltip)
